var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaskLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8907 27.0908L28.1196 16.6812C28.0404 16.4628 28 16.2323 28 16V6H20V16C20 16.2323 19.9595 16.4628 19.8804 16.6812L15.5569 28.6155C15.6503 28.6623 15.7633 28.7148 15.8955 28.7698C17.6113 29.4843 19.8538 29.4843 22.6924 28.1821C25.9879 26.6705 29.1167 26.4488 31.8907 27.0908ZM33.6587 31.9712C33.4102 31.9283 33.1658 31.8374 32.9389 31.6953C32.8126 31.6163 32.4783 31.4506 31.9669 31.2716C29.7877 30.5088 27.2139 30.5088 24.3602 31.8179C20.4834 33.5962 17.0806 33.5962 14.3578 32.4624C14.3004 32.4385 14.2443 32.4145 14.1893 32.3904L11.106 40.9015C10.8254 41.6806 11.052 42 11.9025 42H36.0974C36.9488 42 37.1747 41.6811 36.8951 40.905L33.6587 31.9712ZM16 6H15C13.8954 6 13 5.10457 13 4C13 2.89543 13.8954 2 15 2H33C34.1045 2 35 2.89543 35 4C35 5.10457 34.1045 6 33 6H32V15.6489L40.6572 39.5461C41.8796 42.94 39.7115 46 36.0974 46H11.9025C8.29079 46 6.11992 42.9409 7.34391 39.5426L16 15.6489V6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaskLight);
export default __webpack_public_path__ + "static/media/flaskLight.a59e05b2f853c57fc25425eca3c06d42.svg";
export { ForwardRef as ReactComponent };